import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import {DialogContent, Link} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import {InternalAffairsStatementResponse} from "../../../data/internal-affairs/InternalAffairsStatementResponse";
import {Link as RouterLink} from "react-router-dom";
import {EditorContent} from "../../editor/EditorContent";

interface InternalAffairsStatementViewFormProps {
    statement: InternalAffairsStatementResponse
}

export default function InternalAffairsStatementViewForm(props: InternalAffairsStatementViewFormProps) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button onClick={() => {
                setOpen(true)
            }}>View</Button>
            <Dialog open={open} onClose={handleClose} maxWidth={"md"}>
                <DialogContent sx={{overflow: 'hidden'}}>
                    <DialogContentText>
                        Provider
                    </DialogContentText>
                    <DialogContentText>
                        <Link underline="none"
                              component={RouterLink}
                              to={`/user/${props.statement.providerCommunityId}`}
                        > {props.statement.providerRpName} ({props.statement.providerNick}) </Link>
                    </DialogContentText>
                </DialogContent>
                <DialogContent sx={{overflow: 'hidden'}}>
                    <DialogContentText>
                        Status
                    </DialogContentText>
                    <DialogContentText>
                        {props.statement.status}
                    </DialogContentText>
                </DialogContent>
                <DialogContent sx={{maxHeight: "300px"}}>
                   <EditorContent content={props.statement.request} />
                </DialogContent>
                <DialogContent sx={{maxHeight: "300px"}}>
                    {props.statement.questions && props.statement.questions.map((q, idx) => {
                        return <React.Fragment key={idx}>
                            <EditorContent content={q.question}/>
                            <EditorContent content={q.response ?? ""}/>
                        </React.Fragment>
                    })}
                </DialogContent>
                <DialogContent sx={{overflow: 'hidden'}}>
                    <Button color={"info"} onClick={() => handleClose()}>Close</Button>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}
